// extracted by mini-css-extract-plugin
export default {"heading":"_6eP8N2dAujMVYlYFkX19eA"};